<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '35vw'}"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onHide()"
  [header]="header">

  <ng-template pTemplate="header">
    <div class="header-content">
      <i class="pi pi-copy mr-2"></i>
      <span>Riproponi Intervento</span>
      <div class="codice-scheda-badge">
        <span class="codice-scheda-value">{{ intervento.scheda?.codice | uppercase}}</span>
      </div>
    </div>
  </ng-template>

  <form [formGroup]="form" class="p-fluid">
    <p class="riproponi-text" style="margin-top: 0.5rem; font-size: 1.1rem; color: #495057; text-align: center; font-weight: 500; margin-bottom: 1.5rem;">
      Riproponi l'intervento per l'anno
      <span class="badge"
        [ngStyle]="{
          'background-color': richiesta ? stiliService.getColoreAnnoRichiesta(richiesta) : '#ccc',
          'color': '#ffffff',
          'padding': '4px 8px',
          'border-radius': '6px',
          'display': 'inline-block',
          'margin-left': '8px',
          'font-size': '1rem',
          'font-weight': '600',
          'box-shadow': '0 2px 4px rgba(0,0,0,0.1)'
        }">
        {{ richiesta.anno }}
      </span>
    </p>
    <div class="field">
      <label class="text-right">Importo richiesto nell'anno precedente</label>
      <p-inputNumber
          formControlName="importoRichiesto"
          mode="currency"
          currency="EUR"
          locale="it-IT"
          [style]="{'width': '50%'}"
          [styleClass]="'text-right'">
        </p-inputNumber>
      </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Annulla"
        icon="pi pi-times"
        (onClick)="hide()"
        styleClass="p-button-text">
      </p-button>
      <p-button
        label="Conferma"
        icon="pi pi-check"
        (onClick)="onConferma()"
        styleClass="p-button-success"
        [disabled]="!form.valid">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
